var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$can('read', 'fight-data-form'))?_c('data-form',{attrs:{"channel":_vm.channel,"channel-options":_vm.channelOptions,"channel-item":_vm.channelItem}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }